import React from 'react';
import ContentLoader, { IContentLoaderProps } from 'react-content-loader';

export const BarChartSkeleton = (props: IContentLoaderProps) => (
  <ContentLoader
    viewBox="0 0 330 300"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    style={{ width: '100%', height: '100%', minWidth: '100%' }}
    {...props}
  >
    <rect x="50" y="50" rx="5" ry="5" width="30" height="200" />
    <rect x="100" y="80" rx="5" ry="5" width="30" height="170" />
    <rect x="150" y="100" rx="5" ry="5" width="30" height="150" />
    <rect x="200" y="120" rx="5" ry="5" width="30" height="130" />
    <rect x="250" y="90" rx="5" ry="5" width="30" height="160" />
  </ContentLoader>
);

export const BarChartEmptySkeleton = (props: IContentLoaderProps) => (
  <svg
    viewBox="0 0 330 300"
    fill="#f3f3f3"
    style={{ width: '100%', height: '100%', minWidth: '100%' }}
    {...props}
  >
    <rect x="50" y="50" rx="5" ry="5" width="30" height="200" />
    <rect x="100" y="80" rx="5" ry="5" width="30" height="170" />
    <rect x="150" y="100" rx="5" ry="5" width="30" height="150" />
    <rect x="200" y="120" rx="5" ry="5" width="30" height="130" />
    <rect x="250" y="90" rx="5" ry="5" width="30" height="160" />

    <text
      x="50%"
      y="60%"
      fontSize="16"
      fill="#999999"
      textAnchor="middle"
      dy=".3em"
    >
      No Data Available
    </text>
  </svg>
);
